import { DealerGroupLandingPageRoute } from "../../navigation/NationalRoutes";
import { useSomeRoutes } from "../../navigation/useSomeRoutes";

export const useIsDealerGroup = (): boolean => {
  const isDealerGroup = useSomeRoutes(DealerGroupLandingPageRoute);
  return isDealerGroup;
};
